import { List } from 'immutable';

import State from '../core/State';
import YahooAdAccount from '../entity/YahooAdAccount';
import initialState from '../initialState';

export const setYahooAdAccounts = (yahooAdAccounts: List<YahooAdAccount>) => (state: State): State => ({
  ...state,
  yahooAdAccounts,
});

export const setYahooUploadedCreative = (yahooUploadedCreative: boolean) => (state: State): State => ({
  ...state,
  yahooUploadedCreative,
});

export const setYahooAdAccountTokenId = (tokenId: string) => (state: State): State => ({
  ...state,
  integratedYahooAdAccounts: {
    ...state.integratedYahooAdAccounts,
    tokenId,
  },
});

export const startIntegratedYahooAdAccounts = () => (state: State): State => ({
  ...state,
  integratedYahooAdAccounts: {
    ...state.integratedYahooAdAccounts,
    fetching: state.integratedYahooAdAccounts.fetching + 1,
  },
});

export const setIntegratedYahooAdAccounts = (integratedYahooAdAccounts: List<YahooAdAccount>) => (
  state: State,
): State => ({
  ...state,
  integratedYahooAdAccounts: {
    ...state.integratedYahooAdAccounts,
    adAccounts: integratedYahooAdAccounts,
    fetching: state.integratedYahooAdAccounts.fetching - 1,
  },
});

export const finishIntegratedYahooCommunication = () => (state: State): State => ({
  ...state,
  integratedYahooAdAccounts: {
    ...state.integratedYahooAdAccounts,
    fetching: state.integratedYahooAdAccounts.fetching - 1,
  },
});

export const disposeYahooAdAccounts = () => (state: State): State => ({
  ...state,
  yahooAdAccounts: initialState.yahooAdAccounts,
});
